import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { ProfileService } from 'src/app/shared/services/API/admin-user/profile.service';
import { CompetenceSelectService } from 'src/app/shared/services/API/billing/competence-select.service';


@Component({
  selector: 'app-billing-sigtap-delete-modal',
  templateUrl: './billing-sigtap-delete-modal.component.html',
  styleUrls: ['./billing-sigtap-delete-modal.component.css']
})
export class BillingSigtapDeleteModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
  public dialog: MatDialog, 
  public matDialogRef: MatDialogRef<BillingSigtapDeleteModalComponent>,
  private competenceSelectService: CompetenceSelectService,
  private alertService: AlertService,) { }

  public isLoading:boolean;  

  ngOnInit(): void {
    this.isLoading = false;
  }
  
  close(){
    this.matDialogRef.close({deleteUser: false}); 
  }
  
  clickDelete(){
    
    this.isLoading = true;

    this.competenceSelectService.delete(this.data.idProcedureSigtapCompetence).subscribe((response)=>{
      
      if(response.isError){
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }
      
      this.alertService.show('Sucesso', "Competencia excluido com sucesso!", AlertType.success); 
      this.matDialogRef.close({deleteUser: true}); 
    },
    (error)=>{
      console.log(error)
      this.isLoading = false;
      this.alertService.show('Erro inesperado', error, AlertType.error);
    });
  }
  
  clickCancel(){
    this.matDialogRef.close({deleteUser: false}); 
  }
}
